
import { AppLayoutWithHeader } from "@/components/layout/AppLayoutWithHeader";
import { SubscriptionManagerV3 } from "@/components/subscription/SubscriptionManagerV3";

/**
 * Page d'abonnement
 * 
 * Affiche le gestionnaire d'abonnement V3 avec :
 * - Aperçu du plan actuel
 * - Options Premium (Branding Pro, Seats)
 * - Packs de crédits Pay-as-you-go
 * - Historique des factures
 * 
 * Note: Utilise maintenant BuyCreditModal unifié au lieu de CreditPurchaseModal
 */
export default function Subscription() {
  return (
    <AppLayoutWithHeader
      title="Mon abonnement"
      subtitle="Gérez votre abonnement, achetez des crédits et consultez vos factures"
    >
      <SubscriptionManagerV3 />
    </AppLayoutWithHeader>
  );
}